export default __webpack_public_path__ + "static/media/breadcrumb-bg.f75e4ce9.jpg";